export default __webpack_public_path__ + "static/hero-mobile-b6a9865afb11edf36ca0e21620b68630.png";